import React, { useEffect, useState } from "react";
import Action from "../../components/common/Action";
import Breadcrumb from "../../components/common/Breadcrumb";
import DebounceSearch from "../../components/common/DebounceSearch";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteRecipe,
  getRecipeList,
} from "../../redux/nutrition-recipes/slice";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import CustomTable from "../../components/customtable/CustomTable";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import { deleteSection, getSectionList } from "../../redux/section/slice";

const Section = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sectionDelete, setSectionDelete] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);

  // selector
  const { allSectionList, allRecipesLoading } = useSelector((store) => ({
    allSectionList: store?.sectionData?.getSectionListStatus?.data,
    allRecipesLoading: store?.sectionData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getSectionList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        limit: pageLimit,
      }),
    );
  }, [searchValue, pageCount, pageLimit, sortBy, sortDirection]);

  const deleteSectionId = async () => {
    setIsLoading(true);
    if (!sectionDelete) return;

    try {
      await dispatch(deleteSection(sectionDelete)).unwrap();
      setIsLoading(false);
      setConfirmDelete(false);

      dispatch(
        getSectionList({
          search: searchValue,
          pageCount,
          pageLimit,
          sort_by: sortBy,
          sort_direction: sortDirection,
          limit: pageLimit,
        }),
      );
    } catch (err) {
      console.error("Failed to delete section:", err);
    }
  };
  const capitalizeFirst = (text) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : "";

  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th className="w-16 table-th">No.</th>
      <th className=" table-th">Section Name</th>
      <th className="table-th">Selection Type</th>
      <th className="w-24 table-th">Actions</th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(allSectionList?.data || []).map((item, index) => (
        <tr key={item._id} className="shadow-sm text-mgrey hover:bg-navTheme/5">
          <td className="px-5 py-3">
            {(pageCount - 1) * pageLimit + index + 1}
          </td>
          <td className="px-5 py-3">
            {" "}
            {item?.sectionName ? capitalizeFirst(item.sectionName) : "-"}
          </td>
          <td className="px-5 py-3">
            {item?.selectionType ? capitalizeFirst(item.selectionType) : "-"}
          </td>

          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() =>
                      navigate("/add-edit-section", {
                        state: { section: item, mode: "edit" },
                      })
                    }
                  >
                    View/Edit
                  </li>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      setConfirmDelete(true);
                      setSectionDelete(item?._id);
                    }}
                  >
                    Delete
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );
  return (
    <>
      <div className="space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Sections
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Sections"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          <div>
            <button
              className="bg-themeBtn text-white flex items-center justify-center px-2 py-[7px] rounded uppercase font-figtree text-base w-40 shadow-[0_4px_6px_rgba(0,0,0,0.3)]"
              onClick={() => navigate("/add-edit-section")}
              type="button"
            >
              + Add Section
            </button>
          </div>
        </div>
        <div className="w-full bg-white shadow rounded-lg">
          {allRecipesLoading ? (
            <RippleLoader />
          ) : (
            <CustomTable
              overflowVisibleLg={true}
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              loading={false}
              showPagination={false}
              current={pageCount}
              data={allSectionList?.data}
            />
          )}
        </div>
      </div>
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={deleteSectionId}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default Section;
